import { useAuth } from 'react-oidc-context';
import { getProjectRoles } from 'lib/auth/authUtils';

// Zitadel project-role key that unlocks "Platform Options" (the Super-Admin-only
// settings, e.g. Credit Management). Must match the role key in Zitadel EXACTLY
// (case-sensitive) and the backend gate require_role("Super Admin").
export const SUPER_ADMIN_ROLE = 'Super Admin';

// True when the current user's token carries the `Super Admin` project role.
export const hasSuperAdminRole = (token) => getProjectRoles(token).includes(SUPER_ADMIN_ROLE);

// Reactive variant for components. Reads roles from the REACTIVE OIDC token
// (`auth.user.access_token`), NOT the in-memory tokenStore that lags one render
// behind auth on reload — otherwise Platform Options would flash/stick hidden.
export const useIsSuperAdmin = () => {
  const auth = useAuth();
  return !!auth.isAuthenticated && hasSuperAdminRole(auth.user?.access_token);
};
